import React from 'react';

export const AdditionalInfo = () =>
  <p>
      Individualized estimates of the risk of end-stage kidney failure in the next year were determined using
      multivariable prediction models developed from a population-based cohort of 11,980 adult patients with
      chronic kidney disease hospitalized with a heart attack in Alberta, Canada between 2004-2017. These
      models were then validated in a similar population of 4,024 patients in Alberta, Canada
      between 2016-2019.  These models were further externally validated and updated in a cohort
      of 1,787 patients with CKD, referred to Nephrology, from British Columbia, Canada, between 2004-2020.
      Treatment effects from invasive heart procedures were then applied to these risks for each participant
      to obtain personalized estimates of absolute risk for an individual under each of the two treatment options.
      Results from published randomized controlled trials were used to determine the effects of the treatment
      option on the outcome of end-stage kidney failure. The overall rating of the strength of evidence for the
      outcomes is “weak” (meaning the true effect might be markedly different from the estimated effect).
      The certainty of this evidence was affected by imprecision (there is a wide range of plausible estimates
      around the best estimates of the effects of treatment) and inconsistency (there are differences in effects
      between individual studies), and risk of bias (estimates for end stage kidney failure were from
      observational studies).
  </p>;
